import React, { useEffect, useState } from "react";
import { BrowserRouter, Router, Routes, Route, Navigate } from "react-router-dom";

import Login from './components/login/Login';
import Meta from './components/meta/acessonegado';
import MetasVendedoras from './components/MetasVendedoras/metasvend';
import MetasVendedorasGeral from './components/metavendendorageral/metavendedorageralgerencial';

import MetasVendedorasGeralVend from './components/metavendendorageralvend/metavendedorageralvend';
import MetasVendedorasGerenteLoja from './components/metavendendoragerenteloja/metasvendgerenteloja';
import MetasVendedorasGeralnew from './components/metavendendorageralNEW/metavendedorageralgerencialNEW';
import MetasVendedorasGeralant from './components/metavendendorageralANT/metavendedorageralgerencialANT';

import TipoPagamentoRevend from './components/VendedorasUtils/TipoPagamentoRevend';
import TipoPagamentoRevendGeral from './components/VendedorasUtils/TipoPagamentoRevendGeral';
import AtualizaSenha from "./components/VendedorasUtils/AtualizaSenha";
import EstoqueLogistica from "./components/LogisticaUtils/EstoqueLogistica";
import EstoqueLogisticaComFoto from "./components/LogisticaUtils/EstoqueLogisticaComFoto";
import MetaEscritorio from "./components/AcessoGeral/MetasGeral";
import EstoqueLoja from "./components/VendedorasUtils/EstoqueLoja";
import ResetaSenhaRevend from "./components/VendedorasUtils/ResetaSenhaRevend";


import BarCodeScanner from "./components/ComponentesPrincipais/BarCodeScanner";


export default function MainRoutes(){
const usu_tipo = localStorage.getItem('usu_tipo')

    const [ativaResp, setAtivaResp] = useState(null)
    //Responsividade
    useEffect(()=>{
        if (ativaResp == null){
            if (window.matchMedia("(max-width: 767px)").matches){
            setAtivaResp(true)
            }else{
                setAtivaResp(false)
            }
        }
    },[ativaResp])
    
    useEffect(() => {
    const CACHE_FLAG = "cache_ok";

    const clearCache = async () => {
      if ("caches" in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((key) => caches.delete(key)));
      }

      // marca que j� limpou
      localStorage.setItem(CACHE_FLAG, "true");

      // for�a reload limpo
      window.location.reload();
    };

    if (!localStorage.getItem(CACHE_FLAG)) {
      clearCache();
    }
  }, []);

return(
<Routes>
<Route path="/" element={<Login/>} />
<Route path="/acessonegado" element={<Meta/>} />
<Route path="/metatimebabita" element={<MetaEscritorio ativaResp={ativaResp}/>} />


<Route path="/metavendedoracliente" element={<MetasVendedoras/>} />
<Route path="/metavendedorageralvend" element={ usu_tipo === '1'? <MetasVendedorasGeralVend/> : <Navigate to="/acessonegado" />} />
<Route path="/metavendedorageralgerenteloja" element={usu_tipo === '2'? <MetasVendedorasGerenteLoja/> : <Navigate to="/acessonegado" />} />
<Route path="/metavendedorageralgerencial" element={ usu_tipo === '0' || usu_tipo === '2'? <MetasVendedorasGeral/> : <Navigate to="/acessonegado" />} />
<Route path="/metavendedorageralgerencialnew" element={ usu_tipo === '0' || usu_tipo === '2' ? <MetasVendedorasGeralnew/> : <Navigate to="/acessonegado" />} />
<Route path="/tipopagamentorealizado" element={usu_tipo === '2' || usu_tipo === '1' ? <TipoPagamentoRevend ativaResp={ativaResp}/> : <Navigate to="/acessonegado" />} />
<Route path="/alterarsenha" element={usu_tipo ? <AtualizaSenha /> : <Navigate to="/acessonegado" />} />
<Route path="/metavendedorageralgerencialant" element={usu_tipo === '0' || usu_tipo === '2' || usu_tipo === '1'? <MetasVendedorasGeralant/> : <Navigate to="/acessonegado" /> } />
<Route path="/tipopagamentorealizadoGeral" element={usu_tipo === '0' || usu_tipo === '2' || usu_tipo === '1'? <TipoPagamentoRevendGeral ativaResp={ativaResp}/> : <Navigate to="/acessonegado" />} />
<Route path="/estoqueloja" element={usu_tipo === '1' || usu_tipo === '2' ? <EstoqueLoja ativaResp={ativaResp}/> : <Navigate to="/acessonegado" />} />
<Route path="/estoquelogistica" element={usu_tipo === '3' || usu_tipo === '0' ? <EstoqueLogistica ativaResp={ativaResp}/> : <Navigate to="/acessonegado" />} />
<Route path="/estoquelogisticacomfoto" element={usu_tipo === '0' ? <EstoqueLogisticaComFoto ativaResp={ativaResp}/> : <Navigate to="/acessonegado" />} />
<Route path="/ResetaSenhaRevendora" element={usu_tipo === '0' || usu_tipo === '2' ? <ResetaSenhaRevend ativaResp={ativaResp}/> : <Navigate to="/acessonegado" />} />


<Route path="/BarCodeScanner" element={<BarCodeScanner/>} />

</Routes>
);
}

// 0 gerencial
// 1 VENDEDEDOR
// 2 GERENTE LOJA